import { Form, Formik } from 'formik';
import { ComponentProps, FC } from 'react';

import { AuthFormHeader } from 'src/authentication/sections/AuthFormHeader/AuthFormHeader';
import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { FormikTokenInput } from 'src/general/components/forms/FormikTokenInput/FormikTokenInput';
import { getMicrocopy } from 'src/stores/microcopyStore';

import styles from './Forms.module.scss';
import { FormProps, VerificationTokenFormValues } from './Forms.types';

interface Props
  extends FormProps<VerificationTokenFormValues>,
    Pick<ComponentProps<typeof FormikTokenInput>, 'forceShowResendButton' | 'onResendTokenVerificationCode'> {
  phone: string;
}

const timerLength = 30;
const inputLength = 4;

const initialValues: VerificationTokenFormValues = {
  verificationCode: '',
};

export const VerificationTokenForm: FC<Props> = ({
  phone,
  onBack,
  onSubmit,
  onSubmitTracking,
  onResendTokenVerificationCode,
  forceShowResendButton,
}) => (
  <>
    <AuthFormHeader
      title={getMicrocopy(MICROCOPY.AUTHENTICATION_VERIFICATION_FORM_TITLE)}
      subtitle={getMicrocopy(MICROCOPY.AUTHENTICATION_VERIFICATION_FORM_CAPTION, true, {
        phone,
      })}
      onBack={onBack}
    />
    <Formik initialValues={{ ...initialValues }} validateOnChange={false} onSubmit={onSubmit}>
      {(props) => (
        <Form className={styles.form} noValidate>
          <FormikTokenInput
            isDisabled={props.isSubmitting}
            invalidTokenMessage={props.errors.verificationCode}
            onChange={(val) => {
              props.setFieldValue('verificationCode', val);
            }}
            forceShowResendButton={forceShowResendButton}
            onResendTokenVerificationCode={onResendTokenVerificationCode}
            onError={onSubmitTracking}
            onSubmit={props.submitForm}
            timerLength={timerLength}
            inputLength={inputLength}
          />
        </Form>
      )}
    </Formik>
  </>
);
